import React from 'react'
import { Box } from '@mui/material';
import ErrorImage from "../../assets/images/A-404-Page-Best-Practices-and-Design-Inspiration.jpg"
import { useTheme } from "../../theme/ThemeContext";

const PageNotFound = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        py: 4,
        backgroundColor: theme?.store_background_color,
      }}
    >
      <Box
        component="img"
        src={ErrorImage}
        alt="Error"
        sx={{
          maxHeight: "800px",
          maxWidth: "800px",
          width: "100%",
          height: "auto",
        }}
      />
    </Box>
  )
}

export default PageNotFound